import { Clear } from "@mui/icons-material";
import { Box, Button, TextField, Typography } from "@mui/material";
import Select from "components/ui/select";
import { BiPlus } from "react-icons/bi";

const InvoicePriceTable = ({ formik, fees }) => {
  const handleTotalPriceUpdate = (index, field, value) => {
    if (field === "subtotal") {
      const oldSubtotal = Number(formik.values.invoice_details[index].subtotal);
      // set total tax
      formik.setFieldValue(
        "subtotal",
        Number(formik.values.subtotal) + Number(value) - oldSubtotal
      );
      formik.setFieldValue(
        "total",
        Number(formik.values.total) + Number(value) - oldSubtotal
      );

      // Recalculate item total
      const itemSubtotal = Number(value);
      const itemTax = Number(formik.values.invoice_details[index].tax);
      const itemDiscount = Number(
        formik.values.invoice_details[index].discount
      );
      const itemTotal = itemSubtotal + itemTax - itemDiscount;

      formik.setFieldValue(
        `invoice_details[${index}].total`,
        itemSubtotal || itemTax || itemDiscount ? itemTotal : ""
      );
    } else if (field === "tax") {
      const oldTax = Number(formik.values.invoice_details[index].tax);
      // set total tax
      formik.setFieldValue(
        "tax",
        Number(formik.values.tax) + Number(value) - oldTax
      );
      formik.setFieldValue(
        "total",
        Number(formik.values.total) + Number(value) - oldTax
      );

      // Recalculate item total
      const itemSubtotal = Number(
        formik.values.invoice_details[index].subtotal
      );
      const itemTax = Number(value);
      const itemDiscount = Number(
        formik.values.invoice_details[index].discount
      );
      const itemTotal = itemSubtotal + itemTax - itemDiscount;

      formik.setFieldValue(
        `invoice_details[${index}].total`,
        itemSubtotal || itemTax || itemDiscount ? itemTotal : ""
      );
    } else if (field === "discount") {
      const oldDiscount = Number(formik.values.invoice_details[index].discount);

      // set total discount
      formik.setFieldValue(
        "discount",
        Number(formik.values.discount) + Number(value) - oldDiscount
      );
      formik.setFieldValue(
        "total",
        Number(formik.values.total) - (Number(value) - oldDiscount)
      );

      // Recalculate item total
      const itemSubtotal = Number(
        formik.values.invoice_details[index].subtotal
      );
      const itemTax = Number(formik.values.invoice_details[index].tax);
      const itemDiscount = Number(value);
      const itemTotal = itemSubtotal + itemTax - itemDiscount;

      formik.setFieldValue(
        `invoice_details[${index}].total`,
        itemSubtotal || itemTax || itemDiscount ? itemTotal : ""
      );
    } else if (field === "delete_item") {
      const oldSubtotal = Number(formik.values.invoice_details[index].subtotal);
      const oldTax = Number(formik.values.invoice_details[index].tax);
      const oldDiscount = Number(formik.values.invoice_details[index].discount);
      const oldTotal = Number(formik.values.invoice_details[index].total);

      // Remove tax and dicount
      formik.setFieldValue(
        "subtotal",
        Number(formik.values.subtotal) - oldSubtotal
      );
      formik.setFieldValue("tax", Number(formik.values.tax) - oldTax);
      formik.setFieldValue(
        "discount",
        Number(formik.values.discount) - oldDiscount
      );
      formik.setFieldValue("total", Number(formik.values.total) - oldTotal);

      formik.setFieldValue(
        "invoice_details",
        [...formik.values.invoice_details].filter((invoice, i) => i !== index)
      );
    }
  };

  return (
    <Box sx={{ overflowX: "auto" }}>
      <Box sx={{ width: "100%", minWidth: "700px" }}>
        <Box
          sx={{
            display: "grid",
            gridTemplateColumns: "repeat(6, 1fr) 30px",
            gap: "10px",
            bgcolor: (theme) => theme.palette.primary.main,
            padding: "10px 20px",
            color: "#fff",
          }}
        >
          <Typography>Item</Typography>
          <Typography align="center">Refund Type</Typography>
          <Typography align="center">Amount</Typography>
          <Typography align="center">Tax</Typography>
          <Typography align="center">Discount</Typography>
          <Typography align="center">Item Total</Typography>
          <Box></Box>
        </Box>
        {formik?.values?.invoice_details?.map((singleItem, i) => (
          <Box
            sx={{
              display: "grid",
              gridTemplateColumns: "repeat(6, 1fr) 30px",
              gap: "10px",
              padding: "5px 0",
              borderBottom: "1px solid #ddd",
            }}
          >
            <Select
              options={fees}
              value={formik?.values?.invoice_details[i]?.fee_id}
              onChange={(value) =>
                formik.setFieldValue(`invoice_details[${i}].fee_id`, value)
              }
              selectProps={{ id: "id", label: "name" }}
            />
            <Select
              options={[
                {
                  id: "refundable",
                  name: "Refundable",
                },
                {
                  id: "non-refundable",
                  name: "Non-Refundable",
                },
              ]}
              value={formik?.values?.invoice_details[i]?.refund_type}
              onChange={(value) =>
                formik.setFieldValue(`invoice_details[${i}].refund_type`, value)
              }
              selectProps={{ id: "id", label: "name" }}
            />

            <TextField
              type="number"
              className="numberInput"
              size="small"
              placeholder="Amount *"
              value={formik.values.invoice_details[i].subtotal ?? ""}
              onChange={(e) => {
                const value =
                  e.target.value === "" ? "" : Number(e.target.value);
                formik.setFieldValue(`invoice_details[${i}].subtotal`, value);
                handleTotalPriceUpdate(i, "subtotal", value || 0);
              }}
              InputProps={{
                inputProps: {
                  style: { textAlign: "right" },
                },
              }}
            />
            <TextField
              type="number"
              className="numberInput"
              size="small"
              placeholder="Tax"
              value={formik.values.invoice_details[i].tax ?? ""}
              onChange={(e) => {
                const value =
                  e.target.value === "" ? "" : Number(e.target.value);
                formik.setFieldValue(`invoice_details[${i}].tax`, value);
                handleTotalPriceUpdate(i, "tax", value || 0);
              }}
              InputProps={{
                inputProps: {
                  style: { textAlign: "right" },
                },
              }}
            />
            <TextField
              type="number"
              className="numberInput"
              InputProps={{
                inputProps: {
                  style: { textAlign: "right" },
                },
              }}
              placeholder="Discount"
              size="small"
              value={formik.values.invoice_details[i].discount ?? ""}
              onChange={(e) => {
                const value =
                  e.target.value === "" ? "" : Number(e.target.value);
                formik.setFieldValue(`invoice_details[${i}].discount`, value);
                handleTotalPriceUpdate(i, "discount", value || 0);
              }}
            />
            <TextField
              InputProps={{
                readOnly: true,
                inputProps: {
                  style: { textAlign: "right" },
                },
              }}
              placeholder="Item Total"
              size="small"
              value={formik.values.invoice_details[i].total}
            />

            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                cursor: "pointer",
              }}
              onClick={() => handleTotalPriceUpdate(i, "delete_item")}
            >
              <Clear />
            </Box>
          </Box>
        ))}
        <Box
          sx={{
            padding: "10px 0",
          }}
        >
          <Button
            startIcon={<BiPlus />}
            variant="outlined"
            onClick={() =>
              formik.setFieldValue("invoice_details", [
                ...formik.values.invoice_details,
                {
                  refund_type: "",
                  fee_id: "",
                  tax: "",
                  discount: "",
                  subtotal: "",
                  total: "",
                },
              ])
            }
          >
            Add
          </Button>
        </Box>
      </Box>
    </Box>
  );
};

export default InvoicePriceTable;